/* ============================================================
   RAJATHEE — Per-saree Checkout Intercept Modal
   Exposes window.interceptCheckout, called from inline onclick
   in snippets/cart-summary.liquid. Defer-safe — the function is
   defined before DOMContentLoaded, well before the checkout
   button can be clicked.
   Extracted from layout/theme.liquid.
   ============================================================ */
(function () {
  var FALL_PICO_ID    = 47195287748791;
  var RTW_ID          = 47195287781559;
  var FALL_PICO_PRICE = 180;
  var RTW_PRICE       = 1100;

  function analyseCart(cart) {
    var items    = cart.items;
    var addonMap = {};
    items.forEach(function (item) {
      var parentKey = item.properties && item.properties['_parent_key'];
      if (parentKey) addonMap[parentKey] = item;
    });
    var actionable = [];
    items.forEach(function (item) {
      var isAddon = item.properties && item.properties['_parent_key'];
      if (isAddon) return;
      var addon   = addonMap[item.key];
      var addonId = addon ? addon.variant_id : null;
      if (addonId === RTW_ID) return;
      actionable.push({
        key:     item.key,
        title:   item.product_title,
        hasFP:   addonId === FALL_PICO_ID,
        addonKey: addon ? addon.key : null
      });
    });
    return actionable;
  }

  function closeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component, cart-drawer');
    if (cartDrawer && typeof cartDrawer.close === 'function') { cartDrawer.close(); return; }
    var overlay = document.querySelector('[aria-modal="true"][role="dialog"]');
    if (overlay) {
      var closeBtn = overlay.querySelector('button[aria-label*="Close"], button[aria-label*="close"]');
      if (closeBtn) { closeBtn.click(); return; }
    }
  }

  function removeModal() {
    var el = document.getElementById('rj-checkout-overlay');
    if (el) el.remove();
  }

  function buildModal(actionableItems) {
    removeModal();
    closeCartDrawer();

    if (!actionableItems || actionableItems.length === 0) {
      proceedToCheckout();
      return;
    }

    var selections = {};
    actionableItems.forEach(function (s) {
      selections[s.key] = { choice: s.hasFP ? 'fp' : 'none', addonKey: s.addonKey, hasFP: s.hasFP };
    });

    var sareeRowsHTML = actionableItems.map(function (s) {
      if (s.hasFP) {
        var rtwUpgradePrice = RTW_PRICE - FALL_PICO_PRICE;
        return '<div class="rj-saree-row" data-saree-key="' + s.key + '"><p class="rj-saree-name">' + s.title + '</p><div class="rj-saree-choices"><button class="rj-choice-btn rj-active" data-saree="' + s.key + '" data-choice="fp">Keep Fall &amp; Pico <span style="opacity:.6;font-size:11px">(+₹' + FALL_PICO_PRICE + ')</span></button><button class="rj-choice-btn" data-saree="' + s.key + '" data-choice="rtw">Upgrade to Ready to Wear <span style="opacity:.6;font-size:11px">(+₹' + rtwUpgradePrice + ')</span></button></div></div>';
      } else {
        return '<div class="rj-saree-row" data-saree-key="' + s.key + '"><p class="rj-saree-name">' + s.title + '</p><div class="rj-saree-choices"><button class="rj-choice-btn rj-active" data-saree="' + s.key + '" data-choice="none">No finishing</button><button class="rj-choice-btn" data-saree="' + s.key + '" data-choice="fp">Fall &amp; Pico <span style="opacity:.6;font-size:11px">(+₹' + FALL_PICO_PRICE + ')</span></button><button class="rj-choice-btn" data-saree="' + s.key + '" data-choice="rtw">Ready to Wear <span style="opacity:.6;font-size:11px">(+₹' + RTW_PRICE + ')</span></button></div></div>';
      }
    }).join('');

    var overlay = document.createElement('div');
    overlay.id = 'rj-checkout-overlay';

    var box = document.createElement('div');
    box.className = 'rj-modal-box';
    box.innerHTML = '<p class="rj-modal-title">Before you checkout</p><p class="rj-modal-subtitle">Would you like finishing services for your saree(s)?</p>' + sareeRowsHTML + '<button class="rj-modal-proceed" id="rj-modal-proceed">Confirm &amp; Proceed to Checkout</button><button class="rj-modal-skip" id="rj-modal-skip">Skip to checkout</button>';

    overlay.appendChild(box);
    document.body.appendChild(overlay);
    overlay.getBoundingClientRect();

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) return;
      var btn = e.target.closest('.rj-choice-btn');
      if (btn) {
        var sareeKey = btn.dataset.saree;
        var choice   = btn.dataset.choice;
        overlay.querySelectorAll('.rj-choice-btn[data-saree="' + sareeKey + '"]')
          .forEach(function (b) { b.classList.remove('rj-active'); });
        btn.classList.add('rj-active');
        selections[sareeKey].choice = choice;
      }
    });

    document.getElementById('rj-modal-skip').addEventListener('click', function () {
      proceedToCheckout();
    });

    document.getElementById('rj-modal-proceed').addEventListener('click', function () {
      applySelectionsAndCheckout(selections, actionableItems);
    });
  }

  function applySelectionsAndCheckout(selections, actionableItems) {
    var proceedBtn = document.getElementById('rj-modal-proceed');
    var skipBtn    = document.getElementById('rj-modal-skip');
    if (proceedBtn) { proceedBtn.textContent = 'Please wait…'; proceedBtn.disabled = true; }
    if (skipBtn)    skipBtn.disabled = true;

    var removals  = [];
    var additions = [];

    actionableItems.forEach(function (s) {
      var sel = selections[s.key];
      if (!sel) return;
      var currentState = s.hasFP ? 'fp' : 'none';
      var newChoice    = sel.choice;
      if (newChoice === currentState) return;
      if (s.addonKey) removals.push(s.addonKey);
      if (newChoice === 'fp')  additions.push({ variantId: String(FALL_PICO_ID), title: s.title, sareeKey: s.key });
      if (newChoice === 'rtw') additions.push({ variantId: String(RTW_ID),       title: s.title, sareeKey: s.key });
    });

    removeItems(removals)
      .then(function () { return addItemsSequentially(additions); })
      .then(function () { return proceedToCheckout(); })
      .catch(function (err) {
        console.warn('RJ addon apply error:', err);
        proceedToCheckout();
      });
  }

  function removeItems(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('remove failed: ' + r.status);
      return r.json();
    });
  }

  function addItemsSequentially(additions) {
    if (!additions.length) return Promise.resolve();
    var items = additions.map(function (a) {
      return {
        id: a.variantId,
        quantity: 1,
        properties: {
          'Add-on for': a.title,
          '_parent_key': a.sareeKey
        }
      };
    });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        console.error('Cart add failed:', r.status, r.statusText);
        throw new Error('add failed: ' + r.status);
      }
      return r.json();
    }).catch(function (err) {
      console.error('Error adding items:', err);
      throw err;
    });
  }

  function proceedToCheckout() {
    removeModal();
    ['cart:refresh', 'cart:updated', 'cart:update'].forEach(function (evName) {
      document.dispatchEvent(new CustomEvent(evName, { bubbles: true }));
    });
    setTimeout(function() {
      window.location.href = '/checkout';
    }, 50);
  }

  window.interceptCheckout = function (event) {
    if (event) { event.preventDefault(); event.stopImmediatePropagation(); }

    function fetchAndBuild(retries) {
      if (retries === undefined) retries = 3;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var actionable = analyseCart(cart);
          if (actionable.length === 0) {
            if (retries > 0) {
              setTimeout(function() { fetchAndBuild(retries - 1); }, 300);
              return;
            }
            window.location.href = '/checkout';
            return;
          }
          buildModal(actionable);
        })
        .catch(function (err) {
          console.error('Checkout intercept error:', err);
          window.location.href = '/checkout';
        });
    }

    fetchAndBuild();
  };
})();
